import { useEffect } from 'react'
import {
  Box,
  Text,
  Flex,
  Progress,
  Icon,
} from '@chakra-ui/react'
import { FaCoins } from 'react-icons/fa'
import { useNavigate } from "react-router";
import { useTokenStore } from '../../Store/useTokenStore'
import { useTokenFetcher } from '../../hooks/useTokenFetcher'
import { useBreadcrumbs } from '../../contexts/BreadcrumbProvider';

export const TokenUsageBar = ({id, accountType = "Free"}) => {
  const { refreshTokens } = useTokenFetcher()
  const { tokenData } = useTokenStore()
  const { addBreadcrumb } = useBreadcrumbs()
  const navigate = useNavigate()

  useEffect(() => {
    refreshTokens(id)
  }, [id, refreshTokens])

  const { extraCredits, creditLimit, creditsUsed, totalCredits } = tokenData;

  
  const isOverLimit = creditsUsed > totalCredits;
  const cappedUsed = isOverLimit ? totalCredits : creditsUsed;
  const percent = totalCredits === 0 ? '0.0' : ((cappedUsed / totalCredits) * 100);
  const overageAmount = Math.round((creditsUsed - totalCredits) * 100) / 100;

  return (
    <Box 
        pb={4} 
        cursor="pointer" 
        width="100%" 
        onClick={() => {
            navigate('/credits-info')
            addBreadcrumb("Credits Info", '/credits-info', true)
        }}
    >
      <Flex align="center" justify="space-between" mb={1}>
        <Flex align="center" gap={2}>
          <Icon as={FaCoins} color="orange.400" boxSize={4} />
          <Text fontWeight="bold" fontSize="lg" color={isOverLimit ? 'red.600' : 'gray.500'}>{(creditLimit - creditsUsed) + extraCredits}</Text>
          { isOverLimit ? 
            <Text fontSize="sm" color="red.600">exceeded credit limit</Text> : 
            <Text fontSize="sm" color="gray.500">available credits</Text>
          }
        </Flex>

        {/* <Text fontSize="sm" color="gray.500">{percent}%{isOverLimit ? ` (+${overageAmount})` : ''}</Text> */}
      </Flex>

      {/* <Progress
        value={Number(percent)}
        colorScheme={isOverLimit ? 'red' : 'purple'}
        size="sm"
        borderRadius="full"
      /> */}
    </Box>
  )
}
